// extracted by mini-css-extract-plugin
export default {"controls":"PlanogramSection_controls__AwESg","placeHolderShimmer":"PlanogramSection_placeHolderShimmer__-bQR6"};